import { useQuery } from "@tanstack/react-query";
import logoFallback from "@assets/ratt-order-logo.jpeg";

export function useCompanyLogo() {
  const { data: settings } = useQuery<Record<string, string>>({
    queryKey: ["/api/settings"],
    staleTime: 5 * 60 * 1000,
  });

  const logoUrl = settings?.companyLogo || logoFallback;
  return logoUrl;
}
